__turbopack_context__.v({
  "theme": "ThemeSelector-module-sass-module__4EMkPW__theme",
  "theme__active": "ThemeSelector-module-sass-module__4EMkPW__theme__active",
  "theme__active_overlay": "ThemeSelector-module-sass-module__4EMkPW__theme__active_overlay",
  "theme__icon": "ThemeSelector-module-sass-module__4EMkPW__theme__icon",
});
